/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 14:24:03
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Table/SizeFittingTable.tsx
 */
import css from './GlobalTable.less';
import React, { useMemo } from 'react';
import { clomeWidth } from './tools/calculate';
import Table from './Table';
import { ChangeSize } from 'src/tools/customHooks';
import {
  expandsWidth,
  rowSelectionWidth,
  yScrollWidth,
} from 'src/tools/constant';
//通过控制 col 里面default 值来控制 列是否显示
const SizeFittingTable = (props) => {
  const {
    columns,
    id,
    expandable,

    dataSource,
    rowSelection,
    className,
    scroll = { x: 'max-content' },
    extraFixedWidth = 0,
    ...rest
  } = props;
  const { y } = scroll;
  const tableSize = ChangeSize(id);
  //console.log('tablesize', tableSize);

  const fittingColumns = useMemo(() => {
    const displayColumns = columns.filter((column) => column.default);
    // const expandsWidth = 50;
    // const rowSelectionWidth = 80;
    // const yScrollWidth = 24;
    let fixedWidth = extraFixedWidth || 0;
    if (expandable) {
      fixedWidth = fixedWidth + expandsWidth;
    }
    if (rowSelection) {
      fixedWidth = fixedWidth + rowSelectionWidth;
    }
    if (y) {
      fixedWidth = fixedWidth + yScrollWidth;
    }

    const columnsFilterCalculate = clomeWidth(
      displayColumns,
      tableSize,
      fixedWidth,
    );

    const allFixed = !!!columnsFilterCalculate.find((i) => {
      return i.minWidth; // 没有可以自由拉伸的了
    });
    if (allFixed) {
      const lastList = {
        title: '',
        className: css.noPadding,
        dataIndex: '',
        default: true,
        optional: false,
        width: 0,
      };
      columnsFilterCalculate.push(lastList);
    }

    return columnsFilterCalculate;
  }, [tableSize, columns, extraFixedWidth]);
  //console.log('fittingColumns', fittingColumns);

  return (
    <div id={id}>
      <Table
        className={`${css.editableTable} ${className || ''}`}
        expandable={expandable}
        rowSelection={rowSelection}
        scroll={scroll}
        columns={fittingColumns}
        dataSource={dataSource}
        {...rest}
      />
    </div>
  );
};
export default SizeFittingTable;
